// This file is used by es2015 modules - it would be better to keep it in commonJS
const createConfig = require('12factor-config');

const scheme = {
  api_url: {
    env: 'API_URL',
    type: 'string',
    default: '/api',
    required: true,
  },
  info_url: {
    env: 'INFO_URL',
    type: 'string',
    default: '/rest-api/iam/v2',
    required: true,
  },
  sign_in_url: {
    env: 'SIGN_IN_URL',
    type: 'string',
    default: '/Platform/login?goto=',
    required: true,
  },
  sign_out_url: {
    env: 'SIGN_OUT_URL',
    type: 'string',
    default: '/logout',
    required: true,
  },
  switch_profiles_url: {
    env: 'SWITCH_PROFILES_URL',
    type: 'string',
    default: '/Platform/profile/select',
    required: true,
  },
  buy_license_phone: {
    env: 'BUY_LICENSE_PHONE',
    type: 'string',
    default: '1.800.799.0600',
    required: true,
  },
};

const config = createConfig(scheme);

module.exports = config;
module.exports.scheme = scheme; // @TODO mmodifies config object too
